/**
 * Rounds a value to the nearest step for projected LTC cost display (standard rounding: e.g. 13 → 10 for step 10).
 * Normalizes to whole dollars first so the rounded result matches the tooltip (formatCurrency uses 0 decimals).
 * step === 0: no rounding (return normalized whole-dollar value).
 * step > 0: round to nearest step (e.g. 10, 100, 1000).
 * Returns 0 for null, undefined, or NaN.
 */
export function roundToNearest(
  value: number | undefined | null,
  step: number,
): number {
  if (value == null || Number.isNaN(value)) {
    return 0;
  }
  const normalized = Math.round(value);
  if (step <= 0) {
    return normalized;
  }
  return Math.round(normalized / step) * step;
}

/** Rounds to nearest $10. Use roundToNearest(value, 10) for consistency. */
export function roundToNearest10(value: number | undefined | null): number {
  return roundToNearest(value, 10);
}
